import React from 'react';
import PropTypes from 'prop-types';
import TimelineContent from '@mui/lab/TimelineContent';
import { withStyles } from '@mui/styles';

const CustomTimelineContent = withStyles({
  root: {},
})(TimelineContent);

const UiTimelineContent = ({ children, ...props }) => {
  return <CustomTimelineContent {...props}>{children}</CustomTimelineContent>;
};

UiTimelineContent.propTypes = {
  children: PropTypes.array,
};

export default UiTimelineContent;
